import { createStrategyMonitorHook } from '../tradingCockpit/createStrategyMonitorHook';

export const useQCockpitMonitor = createStrategyMonitorHook({
    strategyId: 'q_cobra',
    strategyLabel: 'Q Cobra',
});

export const useQCockpitV2Monitor = createStrategyMonitorHook({
    strategyId: 'q_cobra_v2',
    strategyLabel: 'Q Cobra V2',
});

export const useQCockpitV3Monitor = createStrategyMonitorHook({
    strategyId: 'q_cobra_v3',
    strategyLabel: 'qCobra.V3',
});

export const useQCockpitV4Monitor = createStrategyMonitorHook({
    strategyId: 'q_cobra_v4',
    strategyLabel: 'qCobra.V4',
});

export const useChanakyaMonitor = createStrategyMonitorHook({
    strategyId: 'chanakya',
    strategyLabel: 'Chanakya',
});

export const useChanakyaInverseMonitor = createStrategyMonitorHook({
    strategyId: 'chanakya_inverse',
    strategyLabel: 'Chanakya Inverse',
});

export const useViduraMonitor = createStrategyMonitorHook({
    strategyId: 'vidura',
    strategyLabel: 'Vidura',
});
